// src/utils/rankSites.js
//
// Portfolio ranking ported from the legacy monolith. Ranks are stable
// across stage/region/business/lease filters because the rank is assigned
// to the FULL portfolio before filtering — see PortfolioView's pipeline.
//
// Rules:
//   - All sites sort by stage order (STAGE_ORDER), then by sqft descending
//     so the biggest sites in each stage take the top ranks within their group.
//   - Stages not listed in STAGE_ORDER (unknown values) fall to priority 99.
//   - rank = 1-based index into the unified sorted list.
//
// LSE-SORT-CONSOLIDATION-FOLLOWUP: `closed` added to STAGE_ORDER at position 5
// (after vacated: 4). The separate alpha-trailing closed bucket has been
// removed; closed sites now flow through the unified stage-order + sqft DESC
// sort path, matching the spec's Retired secondary sort (sqft DESC).

// Lifecycle order is independent of default active scope.
// Retired negotiating/prospecting values still sort to priority 99.
export const STAGE_ORDER = {
  draft:       0,
  build:       1,
  operational: 2,
  dormant:     3,
  vacated:     4,
  closed:      5,
};

export function rankSites(locations) {
  const list = Array.isArray(locations) ? locations : [];
  return [...list]
    .sort((a, b) => {
      const sd = (STAGE_ORDER[a.stage] ?? 99) - (STAGE_ORDER[b.stage] ?? 99);
      if (sd !== 0) return sd;
      const sqftDiff = (b.sqft || 0) - (a.sqft || 0);
      if (sqftDiff !== 0) return sqftDiff;
      // ID tiebreaker: ascending so same-sq-ft pairs within a group are stable.
      return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    })
    .map((s, i) => ({ ...s, rank: i + 1 }));
}
